
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "RelatorioIndex",
        components: {    },  
    }) 
    export default class RelatorioIndex extends Vue {
         
    }
  
